import {Injectable, Inject} from '@angular/core';
import {HttpClient, HttpResponse, HttpParams, HttpHeaders} from '@angular/common/http';
import {ParamMap, Router, NavigationExtras, ActivatedRoute, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {throwError, of} from 'rxjs';
import {map, finalize} from 'rxjs/operators';
import {LangService} from '../lang/lang.service';
import {environment} from '../../../environments/environment';
import {ConfigService} from '../config/config.service';
import {CountriesService} from '../countries/countries.service';
import {AirportsService} from '../airports/airports.service';
import {FiltersService} from '../filters/filters.service';
import {AuthenticationService} from '../authentication/authentication.service';
import {BehaviorSubject} from 'rxjs';
import {ModalService} from '../modal/modal.service';
import {ActivityIndicatorComponent} from '../../Components/shared/activity-indicator/activity-indicator.component';
import {HeaderService} from '../header/header.service';
import {ImageLoaderService} from '../image-loader/image-loader.service';
import { AnalyticsService } from '../analytics/analytics.service';
import { WINDOW } from '../window/window.service';

@Injectable({
    providedIn: 'root'
})
export class LuckyService {

    luckyOption: any = {};

    public luckyResponse: any;
    public sameTrip;
    public changeType;
    private changeObject;
    private selectedAccommodation: any;
    public requestTime1;
    public requestTime2;
    private timeOut = false;
    private tripBreaksCount = 0;
    public isTripBreakActive = false;
    public isTripBreakDone = false;
    public isPerAdultTitle = false;

    private luckyObj = new BehaviorSubject<any>({});
    luckyObjObs = this.luckyObj.asObservable();
    public luckyObjSubscribed: any;
    /**
     * @this
     * 0 = offline;
     * 1 = searching;
     * 2 = error;
     * @description: only used now for the activity indicator component to switch between searching and TNF states.
     */
    public luckCallStatus = new BehaviorSubject<any>({}); // this should be a number and have a dictionary pointing

    public isluckyCallCanceled = new BehaviorSubject(false); // this should be a number and have a dictionary pointing
    private isCanceled = false;


    public invalidCachedTrip = false;
    private isCachedTrip = false;
    private cachedTripExist = false;
    private cachedTripObject: any;
    private cachedTripCallRunning = false;

    private cachedImagesLoaded = false;
    private cachedTripRequested = false;

    constructor(private http: HttpClient, public router: Router,
                private lang: LangService,
                private conf: ConfigService,
                private country: CountriesService,
                private airportsService: AirportsService,
                private filtersService: FiltersService,
                private authenticationService: AuthenticationService,
                private modalService: ModalService,
                private headerService: HeaderService,
                private imageLoaderService: ImageLoaderService,
                private analytics: AnalyticsService,
                @Inject(WINDOW) private window: Window,
    ) {
        this.luckyObjObs.subscribe(res => {
            this.luckyObjSubscribed = res;
        });
        this.isluckyCallCanceled.subscribe((requestStatus) => {
            if (this.luckCallStatus.getValue() === 1 && requestStatus) {
                this.isCanceled = requestStatus;
            } else if (!requestStatus) {
                this.isCanceled = requestStatus;
            } else {
                this.isluckyCallCanceled.next(false);
                this.isCanceled = false;
            }
        });
        this.lang.cl.subscribe(newLang => {
            this.invalidateCachedTrip();
        });
        this.filtersService.filtersActivityObject.subscribe(res => {
            this.invalidateCachedTrip();
        });
    }

    requestForCachedTrip() {
        this.isCachedTrip = true;
        this.lucky().subscribe(response => {
            if (response.trip_found) {
                this.cachedTripObject = response;
                this.cachedTripExist = true;
                response.cachedTrip = true;
                // should add image loader so it would cache cached trip images
                // (need to check if its done the old caching for images)
                // this.imageLoaderService.cachedTripImages(response);
                this.cachedTripAsyncBehavior(response);
            }
            this.isCachedTrip = false;
        }, err => {
            this.cachedTripExist = false;
            this.isCachedTrip = false;
            this.cachedTripCallRunning = false;
        });
    }

    startCachedTripJourney() {
        return new Observable((observer) => {
            setTimeout(() => {
                if (this.cachedTripExist) {
                    this.luckyResponse = this.cachedTripObject;
                    this.cachedTripRequested = true;
                    this.cachedTripAsyncBehavior(this.luckyResponse);
                    observer.next(this.luckyResponse);
                } else {
                    this.cachedTripRequested = true;
                    return this.startCachedTripJourney();
                }
            }, 1800);
        });
    }

    invalidateCachedTrip() {
        this.cachedTripExist = false;
        this.cachedTripObject = null;
    }


    initActivityIndicator(type?: string, sameTrip?: boolean) {
        const inputs = {
            requestStatus: this.luckCallStatus,
            requestCanceled: this.isluckyCallCanceled,
            activityIndicator: true,
            type: type,
            isSameTrip: sameTrip ? sameTrip : false
        };
        this.modalService.init(ActivityIndicatorComponent, inputs, {});
    }

    lucky(currentTrip?, changeType?, changedObj?, destinationObject?): Observable<any> {
        if (this.cachedTripCallRunning) {
            this.initActivityIndicator('lucky', false);
            this.luckCallStatus.next(1);
            return this.startCachedTripJourney();
        }
        if (this.cachedTripExist && !this.invalidCachedTrip && !currentTrip &&
            (this.getUserBudget() ===
                (this.cachedTripObject.data.trip.budget / this.cachedTripObject.data.trip.people))) {
            this.initActivityIndicator('lucky', false);
            this.luckCallStatus.next(1);
            return this.startCachedTripJourney();
            // return cachedTripTimer;
        }
        if (!this.isCachedTrip) {
            if (currentTrip) {
                this.initActivityIndicator('lucky', true);
            } else {
                if (destinationObject && destinationObject.type === 'route') {
                    this.initActivityIndicator('destination', false);
                } else {
                    this.initActivityIndicator('lucky', false);
                }
            }
            this.luckCallStatus.next(1);
            this.sameTrip = currentTrip;
            this.changeType = changeType;
            this.changeObject = changedObj;
        } else {
            this.sameTrip = false;
            this.changeType = undefined;
            this.changeObject = undefined;
            this.cachedTripCallRunning = true;
        }
        const luckyURL = environment.apiUrl.baseUrl + environment.apiUrl.services.lucky;
        const _luckyCallHeaders = this.collectLuckyCallPostHeaders();
        let _luckyCallPayload;
        if (destinationObject && (destinationObject.type === 'route' || destinationObject.type === 'destination')) {
            _luckyCallPayload = this.collectDestinationPagePayload(destinationObject);
        } else {
            _luckyCallPayload = this.collectLuckyCallPostPayLoad();
        }
        let requestTimer;
        if (!this.isCachedTrip) {
            requestTimer = setTimeout(() => {
                this.timeOut = true;
                this.isluckyCallCanceled.next(true);
                this.luckCallStatus.next(2);
                this.analytics.logEvent('get-lucky_timeout');
            }, 30000);
        }
        return this.http
            .post(luckyURL, _luckyCallPayload, _luckyCallHeaders)
            .pipe(map(
                (response: any) => {
                    clearTimeout(requestTimer);
                    if (!this.isCachedTrip) {
                        // if (this.isCanceled) {
                        //   this.isluckyCallCanceled.next(false);
                        //   this.luckCallStatus.next(0);
                        //   return {};
                        // }
                        if (!response.trip_found) {
                            this.luckCallStatus.next(2);
                        } else {
                            this.luckyResponse = response;
                            this.tripAsyncBehavior(response);
                        }
                    }
                    return response;
                    // }
                }, (error: any) => {
                    clearTimeout(requestTimer);
                    if (!this.isCachedTrip) {
                        if (this.isCanceled) {
                            this.isluckyCallCanceled.next(false);
                            this.luckCallStatus.next(0);
                            return error;
                        }
                        console.log(error);
                        this.luckCallStatus.next(2);
                        this.luckyResponse = error;
                        this.luckyObjectChanges(error);
                        // this.tripService.calculateTripTotal();
                    }
                    return error;
                }
            )).catch((error) => {
                clearTimeout(requestTimer);
                if (!this.isCachedTrip) {
                    if (this.isCanceled) {
                        this.isluckyCallCanceled.next(false);
                        this.luckCallStatus.next(0);
                        return throwError(error);
                    }
                    this.luckCallStatus.next(2);
                    // this.luckyResponse = error;
                    // this.luckyObjectChanges(error);
                    // this.tripService.calculateTripTotal();
                }
                return throwError(error);
            })
            .pipe(finalize(() => {
                clearTimeout(requestTimer);
                this.authenticationService.updateUserSearchCount();
                this.headerService.luckyCount(this.authenticationService.getUserSearchCount());
            }));
    }

    collectLuckyCallPostHeaders() {
        this.luckyOption.headers = new HttpHeaders({
            'Authorization': 'Bearer ' + this.authenticationService.getUserToken(),
            'Content-Type': 'application/json; charset=UTF-8',
            'deviceToken': this.conf.getUUID(),
        });
        return this.luckyOption.headers;
    }

    collectLuckyCallPostPayLoad() {
        this.luckyOption.params = new HttpParams({});
        this.luckyOption.params = this.luckyOption.params.append('budget_per_person',
            this.sameTrip ? this.conf.configurations.app_config_max_budget : this.getUserBudget());
        if (this.sameTrip && this.changeType !== 'pplCounter') {
            this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.luckyObjSubscribed.data.trip.people);
            this.luckyOption.params =
                this.appendChildrenArrayFromArray(this.luckyOption.params, this.luckyObjSubscribed.data.trip.children_birth_dates);
        } else {
            if (this.changeObject && this.changeObject.type === 'pplCounter') {
                this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.changeObject.pplNum);
                this.luckyOption.params = this.appendChildrenArrayFromArray(this.luckyOption.params, this.changeObject.childrenArray);
            } else {
                this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.getNumberOfPpl());
                this.luckyOption.params = this.appendChildrenArray(this.luckyOption.params);
            }
        }
        // this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.getNumberOfPpl());
        this.luckyOption.params = this.luckyOption.params.append('platform', 'web');
        this.luckyOption.params = this.luckyOption.params.append('language_code', this.lang.getCurrentLang());
        this.luckyOption.params = this.luckyOption.params.append('image_size', '2048');
        this.luckyOption.params = this.luckyOption.params.append('number_of_accommodations',
            this.conf.configurations.app_config_number_of_accommodations_to_return);
        this.luckyOption.params = this.luckyOption.params.append('number_of_activities',
            this.conf.configurations.app_config_number_of_activities_to_return);
        this.luckyOption.params = this.luckyOption.params.append('enable_payments',
            this.conf.configurations.payment_switch === 'yes' ? '1' : '0');
        this.luckyOption.params = this.luckyOption.params.append('enable_suggestions', '1');
        if (this.sameTrip) {
            this.luckyOption.params = this.luckyOption.params.append('destination_id',
                this.luckyObjSubscribed ? this.luckyObjSubscribed.data.travel.destination.id : '0');
        }
        if (this.sameTrip) {
            this.luckyOption.params = this.luckyOption.params.append('activity_id',
                this.conf.getActivityId() ? this.conf.getActivityId() : '0');
        }
        if (this.sameTrip) {
            this.luckyOption.params = this.luckyOption.params.append('hotel_id',
                this.conf.getHotelId() ? this.conf.getHotelId() : '0');
        }
        if (this.sameTrip && this.luckyObjSubscribed.data && this.luckyObjSubscribed.data.trip_type) {
            this.luckyOption.params = this.luckyOption.params.append('trip_type', this.luckyObjSubscribed.data.trip_type);
        }

        // Params not used yet >
        //  for search by country feature.
        // destination_country_code
        // destination_region_id
        //  not known what it do
        // lucky_dates_weights_select

        // if (this.conf.configurations.app_config_where_to_search_flags_switch === 'yes') {
        this.luckyOption.params = this.appendSelectedFlags(this.luckyOption.params);
        // } else {
        //   const whereToObject = this.conf.getSelectedWhereToValues();
        //   if (!whereToObject.groups && !whereToObject.countries) {
        //     this.luckyOption.params = this.appendSelectedFlags(this.luckyOption.params);
        //   }
        // }

        if (this.sameTrip) {
            if (this.changeType === 'dates') {
                // the date object should be saved before this,
                //  not any more, it should be treated as a change for the current trip  only and not saved to filters.
                // this.luckyOption.params = this.handleSelectedDate(this.luckyOption.params);
                // this should be from the change type
                if (this.changeObject && this.changeObject.type === 'dates') {
                    this.luckyOption.params = this.luckyOption.params.append('from_date', this.changeObject.from ? this.changeObject.from : '0');
                    this.luckyOption.params = this.luckyOption.params.append('to_date', this.changeObject.to ? this.changeObject.to : '0');
                } else {
                    this.luckyOption.params = this.handleSelectedDate(this.luckyOption.params);
                }
            } else {
                this.luckyOption.params = this.luckyOption.params.append('from_date',
                    this.luckyObjSubscribed ? this.luckyObjSubscribed.data.trip.from_date : '0');
                this.luckyOption.params = this.luckyOption.params.append('to_date',
                    this.luckyObjSubscribed ? this.luckyObjSubscribed.data.trip.to_date : '0');
            }
        } else {
            this.luckyOption.params = this.handleSelectedDate(this.luckyOption.params);
        }


        this.luckyOption.params = this.handleUserCountry(this.luckyOption.params);
        this.luckyOption.params = this.handleAccommodationTypes(this.luckyOption.params);
        this.luckyOption.params = this.handleAccommodationTags(this.luckyOption.params);
        if (this.sameTrip && this.luckyObjSubscribed) {
            this.luckyOption.params = this.luckyOption.params.append('airport_iata_codes[0]',
                this.luckyObjSubscribed.data.travel.airport_origin.iata_code);
            this.luckyOption.params = this.luckyOption.params.append('use_indirect_flights',
                this.luckyObjSubscribed.data.travel.airport_origin.enable_indirect_flights &&
                this.luckyObjSubscribed.data.travel.airport_origin.enable_indirect_flights === 'yes' ? 1 : 0);
        } else {
            this.luckyOption.params = this.collectWhereToValues(this.luckyOption.params);
            this.luckyOption.params = this.handleAirportSelection(this.luckyOption.params);
        }
        this.luckyOption.params = this.luckyOption.params.append('cahce-cotrol', new Date().getTime());
        return this.luckyOption.params;
    }

    collectLuckyCallHeaders() {
        this.luckyOption.headers = new HttpHeaders({
            'Authorization': 'Bearer ' + this.authenticationService.getUserToken(),
            'Content-Type': 'application/json; charset=UTF-8',
            'deviceToken': this.conf.getUUID(),
        });
        return this.luckyOption.headers;
    }

    collectLuckyCallPayLoad() {
        this.luckyOption.params = new HttpParams({});
        this.luckyOption.params = this.luckyOption.params.append('budget_per_person',
            this.sameTrip ? this.conf.configurations.app_config_max_budget : this.getUserBudget());
        if (this.sameTrip && this.changeType !== 'pplCounter') {
            this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.luckyObjSubscribed.data.trip.people);
            this.luckyOption.params =
                this.appendChildrenArrayFromArray(this.luckyOption.params, this.luckyObjSubscribed.data.trip.children_birth_dates);
        } else {
            if (this.changeObject && this.changeObject.type === 'pplCounter') {
                this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.changeObject.pplNum);
                this.luckyOption.params = this.appendChildrenArrayFromArray(this.luckyOption.params, this.changeObject.childrenArray);
            } else {
                this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.getNumberOfPpl());
                this.luckyOption.params = this.appendChildrenArray(this.luckyOption.params);
            }
        }
        // this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.getNumberOfPpl());
        this.luckyOption.params = this.luckyOption.params.append('platform', 'web');
        this.luckyOption.params = this.luckyOption.params.append('language_code', this.lang.getCurrentLang());
        this.luckyOption.params = this.luckyOption.params.append('image_size', '2048');
        this.luckyOption.params = this.luckyOption.params.append('number_of_accommodations',
            this.conf.configurations.app_config_number_of_accommodations_to_return);
        this.luckyOption.params = this.luckyOption.params.append('number_of_activities',
            this.conf.configurations.app_config_number_of_activities_to_return);
        this.luckyOption.params = this.luckyOption.params.append('enable_payments',
            this.conf.configurations.payment_switch === 'yes' ? '1' : '0');
        this.luckyOption.params = this.luckyOption.params.append('enable_suggestions', '1');
        if (this.sameTrip) {
            this.luckyOption.params = this.luckyOption.params.append('destination_id',
                this.luckyObjSubscribed ? this.luckyObjSubscribed.data.travel.destination.id : '0');
        }
        if (this.sameTrip) {
            this.luckyOption.params = this.luckyOption.params.append('activity_id',
                this.conf.getActivityId() ? this.conf.getActivityId() : '0');
        }
        if (this.sameTrip) {
            this.luckyOption.params = this.luckyOption.params.append('hotel_id',
                this.conf.getHotelId() ? this.conf.getHotelId() : '0');
        }
        if (this.sameTrip && this.luckyObjSubscribed.data && this.luckyObjSubscribed.data.trip_type) {
            this.luckyOption.params = this.luckyOption.params.append('trip_type', this.luckyObjSubscribed.data.trip_type);
        }

        // Params not used yet >
        //  for search by country feature.
        // destination_country_code
        // destination_region_id
        //  not known what it do
        // lucky_dates_weights_select

        // if (this.conf.configurations.app_config_where_to_search_flags_switch === 'yes') {
        this.luckyOption.params = this.appendSelectedFlags(this.luckyOption.params);
        // } else {
        //   const whereToObject = this.conf.getSelectedWhereToValues();
        //   if (!whereToObject.groups && !whereToObject.countries) {
        //     this.luckyOption.params = this.appendSelectedFlags(this.luckyOption.params);
        //   }
        // }

        if (this.sameTrip) {
            if (this.changeType === 'dates') {
                // the date object should be saved before this,
                //  not any more, it should be treated as a change for the current trip  only and not saved to filters.
                // this.luckyOption.params = this.handleSelectedDate(this.luckyOption.params);
                // this should be from the change type
                if (this.changeObject && this.changeObject.type === 'dates') {
                    this.luckyOption.params = this.luckyOption.params.append('from_date', this.changeObject.from ? this.changeObject.from : '0');
                    this.luckyOption.params = this.luckyOption.params.append('to_date', this.changeObject.to ? this.changeObject.to : '0');
                } else {
                    this.luckyOption.params = this.handleSelectedDate(this.luckyOption.params);
                }
            } else {
                this.luckyOption.params = this.luckyOption.params.append('from_date',
                    this.luckyObjSubscribed ? this.luckyObjSubscribed.data.trip.from_date : '0');
                this.luckyOption.params = this.luckyOption.params.append('to_date',
                    this.luckyObjSubscribed ? this.luckyObjSubscribed.data.trip.to_date : '0');
            }
        } else {
            this.luckyOption.params = this.handleSelectedDate(this.luckyOption.params);
        }


        this.luckyOption.params = this.handleUserCountry(this.luckyOption.params);
        this.luckyOption.params = this.handleAccommodationTypes(this.luckyOption.params);
        this.luckyOption.params = this.handleAccommodationTags(this.luckyOption.params);
        if (this.sameTrip && this.luckyObjSubscribed) {
            this.luckyOption.params = this.luckyOption.params.append('airport_iata_codes[0]',
                this.luckyObjSubscribed.data.travel.airport_origin.iata_code);
            this.luckyOption.params = this.luckyOption.params.append('use_indirect_flights',
                this.luckyObjSubscribed.data.travel.airport_origin.enable_indirect_flights &&
                this.luckyObjSubscribed.data.travel.airport_origin.enable_indirect_flights === 'yes' ? 1 : 0);
        } else {
            this.luckyOption.params = this.collectWhereToValues(this.luckyOption.params);
            this.luckyOption.params = this.handleAirportSelection(this.luckyOption.params);
        }
        this.luckyOption.params = this.luckyOption.params.append('cahce-cotrol', new Date().getTime());
        return this.luckyOption.params;
    }

    collectDestinationPagePayload(object) {
        this.luckyOption.params = new HttpParams({});
        this.luckyOption.params = this.luckyOption.params.append('budget_per_person', this.conf.configurations.app_config_max_budget);
        this.luckyOption.params = this.luckyOption.params.append('number_of_people', this.getNumberOfPpl());
        this.luckyOption.params = this.luckyOption.params.append('platform', 'web');
        this.luckyOption.params = this.luckyOption.params.append('language_code', this.lang.getCurrentLang());
        this.luckyOption.params = this.luckyOption.params.append('image_size', '2048');
        this.luckyOption.params = this.luckyOption.params.append('number_of_accommodations',
            this.conf.configurations.app_config_number_of_accommodations_to_return);
        this.luckyOption.params = this.luckyOption.params.append('number_of_activities',
            this.conf.configurations.app_config_number_of_activities_to_return);
        this.luckyOption.params = this.luckyOption.params.append('enable_payments',
            this.conf.configurations.payment_switch === 'yes' ? '1' : '0');
        this.luckyOption.params = this.luckyOption.params.append('enable_suggestions', '1');
        this.luckyOption.params = this.luckyOption.params.append('trip_type', 'destination');
        this.luckyOption.params = this.luckyOption.params.append('destination_id', object.destinationId);
        // this.luckyOption.params = this.luckyOption.params.append('activity_id', this.conf.getActivityId());
        this.luckyOption.params = this.luckyOption.params.append('hotel_id', this.conf.getHotelId() ? this.conf.getHotelId() : object.accommodationId);
        this.luckyOption.params = this.appendSelectedFlags(this.luckyOption.params);
        this.luckyOption.params = this.handleUserCountry(this.luckyOption.params);
        if (object.type === 'route') {
            this.luckyOption.params = this.luckyOption.params.append('airport_iata_code', object.origin.iata_code);
            this.luckyOption.params = this.luckyOption.params.append('use_indirect_flights', object.origin.enable_indirect_flights === 'yes' ? 1 : 0);
        } else {
            this.luckyOption.params = this.handleAirportSelection(this.luckyOption.params);
        }
        this.luckyOption.params = this.luckyOption.params.append('cache-cotrol', new Date().getTime());
        this.luckyOption.params = this.luckyOption.params.append('number_of_trip_days', object.tripDays);
        return this.luckyOption.params;
    }

    handleAirportSelection(paramsObj) {
        const _selectedAirports = this.conf.getSelectedAirports();
        const _countryObj = this.conf.getUserDefaultCountry();
        if (_selectedAirports.length > 0) {
            _selectedAirports.forEach((element, index) => {
                paramsObj = paramsObj.append('airport_iata_codes[' + index + ']', element);
            });
        } else {
            const _defaultAirport = _countryObj.airport;
            paramsObj = paramsObj.append('airport_iata_codes[0]', _defaultAirport.iata_code);
            paramsObj = paramsObj.append('use_indirect_flights',
                _defaultAirport.enable_indirect_flights && _defaultAirport.enable_indirect_flights === 'yes' ? 1 : 0);
        }
        return paramsObj;
    }

    collectWhereToValues(paramsObject) {
        const whereToObject = this.conf.getSelectedWhereToValues();
        if (whereToObject.groups) {
            for (let index = 0; index < whereToObject.destinations_ids.length; index++) {
                const id = whereToObject.destinations_ids[index];
                paramsObject = paramsObject.append('destination_ids[' + index + ']', id);
            }
        } else if (whereToObject.countries) {
            for (let index = 0; index < whereToObject.countries_codes.length; index++) {
                const id = whereToObject.countries_codes[index];
                paramsObject = paramsObject.append('country_codes[' + index + ']', id);
            }
        }
        return paramsObject;
    }

    getUserBudget() {
        return this.conf.getUserBudget();
    }

    getNumberOfPpl() {
        return this.conf.getPeopleCounter();
    }

    appendChildrenArray(paramObj) {
        const childrenArray = this.conf.getChildrenArray();
        for (let i = 0; i < childrenArray.length; i++) {
            paramObj = paramObj.append('children_birth_dates[' + i + ']', childrenArray[i]);
        }
        return paramObj;
    }

    appendChildrenArrayFromArray(paramObj, childrenArray) {
        for (let i = 0; i < childrenArray.length; i++) {
            paramObj = paramObj.append('children_birth_dates[' + i + ']', childrenArray[i]);
        }
        return paramObj;
    }

    appendSelectedFlags(paramsObj) {
        const _selectedFalgs = this.conf.getSelectedFlags();
        let newParamsObj = paramsObj;
        for (let i = 0; i < _selectedFalgs.length; i++) {
            if (_selectedFalgs[i] === 'everything_flag') {
                return paramsObj;
            }
            newParamsObj = newParamsObj.append(_selectedFalgs[i], 1);
        }
        return newParamsObj;
    }

    handleSelectedDate(paramsObj) {
        const _dateObj = this.conf.getSelectedDates();
        let newParamsObj = paramsObj;
        if (_dateObj.date) {
            if (_dateObj.luckyCalender) {
                newParamsObj = newParamsObj.append('from_date', _dateObj.date.from);
                newParamsObj = newParamsObj.append('to_date', _dateObj.date.to);
                return newParamsObj;
            } else if (_dateObj.luckyDates) {
                if (_dateObj.date.nights !== 0) {
                    newParamsObj = newParamsObj.append('number_of_trip_days', _dateObj.date.nights + 1);
                }
                if (_dateObj.date.months.length > 1) {
                    let paramIndex = 0;
                    for (let i = 0; i < _dateObj.date.months.length; i++) {
                        const month = _dateObj.date.months[i];
                        newParamsObj = newParamsObj.append('from_to_months[' + paramIndex + '][' + month + ']', month);
                        paramIndex++;
                        const nextMonth = _dateObj.date.months[i + 1];
                        if (nextMonth) {
                            const diff = moment(nextMonth).diff(moment(month), 'months', true);
                            if (diff === 1) {
                                newParamsObj = newParamsObj.append('from_to_months[' + paramIndex + '][' + month + ']', nextMonth);
                                paramIndex++;
                            }
                        }
                    }
                } else {
                    newParamsObj = newParamsObj.append('from_to_months[0][' + _dateObj.date.months[0] + ']', _dateObj.date.months[0]);
                }
                if (_dateObj.date.weekends) {
                    newParamsObj = newParamsObj.append('weekend_only_trips', 1);
                }
                return newParamsObj;
            } else {
                return newParamsObj;
            }
        } else {
            return paramsObj;
        }
    }

    handleUserCountry(paramsObj) {
        const _countryObj = this.conf.getUserDefaultCountry();
        paramsObj = paramsObj.append('country_code', _countryObj.country_code);
        paramsObj = paramsObj.append('currency_code', _countryObj.currency_code);
        if (this.conf.isCuratedTrip() && !this.authenticationService.isLoggedIn()) {
            paramsObj = paramsObj.append('curated_trip_country_code', _countryObj.country_code);
            this.conf.updateCuratedTripCount();
        } else if (this.authenticationService.isLoggedIn()) {
            this.conf.updateCuratedTripCount(10);
        }
        return paramsObj;
    }

    handleAccommodationTypes(paramsObj) {
        const _accommodationTypes = this.conf.getSelectedAccommodationType();
        for (let i = 0; i < _accommodationTypes.length; i++) {
            paramsObj = paramsObj.append('hotel_type_group_ids[]', _accommodationTypes[i]);
        }
        return paramsObj;
    }

    handleAccommodationTags(paramsObj) {
        const _accommodationTags = this.conf.getSelectedAccommodationTags();
        if (_accommodationTags) {
            for (let i = 0; i < _accommodationTags.length; i++) {
                paramsObj = paramsObj.append('hotel_tag_ids[' + i + ']', _accommodationTags[i]);
            }
            return paramsObj;
        } else {
            return paramsObj;
        }
    }


    luckyObjectChanges(res) {
        this.luckyObj.next(res);
    }

    tripAsyncBehavior(tripObj) {
        if (this.isCachedTrip) {
            return;
        }
        this.imageLoaderService.init(tripObj).then(
            (val) => {
                // this.luckCallStatus.next(0);
                if (this.isCanceled) {
                    this.isluckyCallCanceled.next(false);
                    if (this.timeOut) {
                        this.timeOut = false;
                    } else {
                        this.luckCallStatus.next(0);
                    }
                    return {};
                } else {
                    const showPerAdultTitlePopup = this.showPerAdultTitlePopup(tripObj);
                    if (showPerAdultTitlePopup && !this.isTripBreakDone) {
                        this.tripBreaksCount = this.tripBreaksCount - 1;
                    }
                    tripObj.data.showPerAdultTitlePopup = showPerAdultTitlePopup;
                    const tripBreakStatus = this.tripBreaksCounter(tripObj.data.trip_type);
                    this.luckCallStatus.next(0);
                    this.luckyObjectChanges(tripObj);

                    if (this.router.url.indexOf('/trip') < 0 || this.router.url.indexOf('user/saved') >= 0 || this.router.url.indexOf('user/trips') >= 0) {
                        // this.router.navigate(['/trips']);
                        (this.window as any).location.replace(`${environment.metaUrl}trips`)
                    }
                    if (!tripObj.data.trip_type) {
                        this.requestTime2 = moment().valueOf();
                        this.analytics.logEvent('trip_load', {time: this.requestTime2 - this.requestTime1, cached: false});
                    }
                    if (!this.sameTrip && !(tripObj.data.trip_type && tripObj.data.trip_type === 'scheduled') && !this.cachedTripExist) {
                        this.requestForCachedTrip();
                    }
                    if (!tripBreakStatus && !showPerAdultTitlePopup) {
                        this.modalService.destroy(false, true);
                    }
                }
            },
            (err) => {
            }
        );
    }

    cachedTripAsyncBehavior(cachedTripObject) {
        if (!this.cachedImagesLoaded) {
            this.imageLoaderService.init(cachedTripObject).then(
                (val) => {
                    this.cachedTripCallRunning = false;
                    if (this.isCanceled) {
                        this.isluckyCallCanceled.next(false);
                        if (this.timeOut) {
                            this.timeOut = false;
                        } else {
                            this.luckCallStatus.next(0);
                        }
                        return {};
                    } else {
                        this.luckCallStatus.next(0);
                        this.cachedImagesLoaded = true;
                        if (this.cachedTripRequested) {
                            const showPerAdultTitlePopup = this.showPerAdultTitlePopup(cachedTripObject);
                            if (showPerAdultTitlePopup && !this.isTripBreakDone) {
                                this.tripBreaksCount = this.tripBreaksCount - 1;
                            }
                            cachedTripObject.data.showPerAdultTitlePopup = showPerAdultTitlePopup;
                            const tripBreakStatus = this.tripBreaksCounter(cachedTripObject.data.trip_type);
                            this.cachedTripExist = false;
                            this.cachedTripObject = null;
                            this.luckyObjectChanges(cachedTripObject);
                            if (!cachedTripObject.data.trip_type) {
                                this.requestTime2 = moment().valueOf();
                                this.analytics.logEvent('trip_load', {time: this.requestTime2 - this.requestTime1, cached: true});
                            }
                            if (this.router.url.indexOf('/trip') < 0 || this.router.url.indexOf('user/trips') >= 0 || this.router.url.indexOf('user/saved') >= 0) {
                                // this.router.navigate(['/trips']);
                                (this.window as any).location.replace(`${environment.metaUrl}trips`)
                            }
                            this.cachedTripRequested = false;
                            if (!this.cachedTripExist) {
                                this.requestForCachedTrip();
                            }
                            if (!tripBreakStatus && !showPerAdultTitlePopup) {
                                this.modalService.destroy(false, true);
                            }
                        }
                    }
                }
            );
        } else {
            this.cachedImagesLoaded = false;
            this.cachedTripCallRunning = false;
            if (this.isCanceled) {
                this.isluckyCallCanceled.next(false);
                if (this.timeOut) {
                    this.timeOut = false;
                } else {
                    this.luckCallStatus.next(0);
                }
                return {};
            } else {
                this.luckCallStatus.next(0);
                if (this.cachedTripRequested) {
                    const showPerAdultTitlePopup = this.showPerAdultTitlePopup(cachedTripObject);
                    if (showPerAdultTitlePopup && !this.isTripBreakDone) {
                        this.tripBreaksCount = this.tripBreaksCount - 1;
                    }
                    cachedTripObject.data.showPerAdultTitlePopup = showPerAdultTitlePopup;
                    const tripBreakStatus = this.tripBreaksCounter(cachedTripObject.data.trip_type);
                    this.cachedTripExist = false;
                    this.cachedTripObject = null;
                    this.luckyObjectChanges(cachedTripObject);
                    if (!cachedTripObject.data.trip_type) {
                        this.requestTime2 = moment().valueOf();
                        this.analytics.logEvent('trip_load', {time: this.requestTime2 - this.requestTime1, cached: true});
                    }
                    if (this.router.url.indexOf('/trips') < 0) {
                        // this.router.navigate(['/trips']);
                        (this.window as any).location.replace('https://dev.luckytrip.co.uk/trips');
                    }
                    this.cachedTripRequested = false;
                    if (!this.cachedTripExist) {
                        this.requestForCachedTrip();
                    }
                    if (!tripBreakStatus && !showPerAdultTitlePopup) {
                        this.modalService.destroy(false, true);
                    }
                }
            }
        }
    }

    tripBreaksCounter(tripType) {
        if (!this.sameTrip && (!tripType || tripType === 'explore' || tripType === 'saved' || tripType === 'shared')) {
            if (this.isTripBreakDone) {
                this.tripBreaksCount = 0;
                this.isTripBreakActive = false;
                return false;
            }
            this.tripBreaksCount = this.tripBreaksCount + 1;
            const tripBreaksConfig = this.conf.getTripBreaksConfig();
            if (this.tripBreaksCount % tripBreaksConfig === 0) {
                this.isTripBreakActive = true;
                this.tripBreaksCount = 0;
                return true;
            } else {
                this.isTripBreakActive = false;
                return false;
            }
        }
    }

    showPerAdultTitlePopup(tripObject: any): boolean {
        const childrenLength = tripObject.data.trip.children_birth_dates ? tripObject.data.trip.children_birth_dates.length : 0;
        const perAdultTitle = this.isPerAdultTitle;
        if (perAdultTitle && childrenLength === 0) {
            this.isPerAdultTitle = false;
            return false;
        }
        if (childrenLength > 0 && !perAdultTitle) {
            this.isPerAdultTitle = true;
            return true;
        } else {
            return false;
        }
    }

}
